import React, { useCallback, useEffect, useState } from "react";
import { fetchSales } from "./SaleAction";
import SalesGallery from "./SaleGallery";
import Pagination from "../Pagination/Pagination";
import { useTranslation } from "react-i18next";
import { Calendar, CalendarCheck, Printer } from "lucide-react";
import SelectField from "../Inputs/SelectField";
import PrintReceipt from "../Print/PrintReceipt";
import { getMe } from "../Navbar/LogutAction";

function Sale() {
  const { t, i18n } = useTranslation();

  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const [saleInvoiceId, setSaleInvoiceId] = useState("");
  const [sales, setSales] = useState([]);
  const [page, setPage] = useState(1);
  const perPage = 10;
  const [total, setTotal] = useState(0);

  const [showMoreMap, setShowMoreMap] = useState({});
  const [showDetailsMap, setShowDetailsMap] = useState({});
  const [printData, setPrintData] = useState(null);
  const [user, setUser] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("user")) || null;
    } catch (e) {
      return null;
    }
  });

  useEffect(() => {
    const fetchUserData = async () => {
      try {
        const data = await getMe();
        if (data?.data) {
          setUser(data.data);
          localStorage.setItem("user", JSON.stringify(data.data));
        }
      } catch (e) {}
    };
    fetchUserData();
  }, []);

  const canPrint =
    user?.print_status === true ||
    user?.print_status === 1 ||
    user?.print_status === "1" ||
    user?.print_status === "true";

  const handlePrint = (sale, mode) => {
    setPrintData({ sale, mode });
    setTimeout(() => {
      window.print();
    }, 100);
  };

  const toggleDetails = (detailId) => {
    setShowDetailsMap((prev) => ({
      ...prev,
      [detailId]: !prev[detailId],
    }));
  };

  const fetchSalesForDropdown = useCallback(
    async ({ search, page, limit }) => {
      const res = await fetchSales(
        "not_complete",
        page,
        limit,
        from,
        to,
        "Glass",
        search
      );

      return {
        data: res?.data || [],
        hasMore: page * limit < (res?.total || 0),
      };
    },
    [from, to]
  );

  useEffect(() => {
    const run = async () => {
      try {
        const data = await fetchSales(
          "not_complete",
          page,
          perPage,
          from,
          to,
          "Glass",
          saleInvoiceId
        );
        setSales(data?.data || []);
        setTotal(data?.total || 0);
      } catch (err) {
        console.error("Error fetching sales data:", err);
      }
    };

    run();
  }, [page, from, to, saleInvoiceId]);
  console.log(sales);
  const prevPage = () => setPage((p) => Math.max(1, p - 1));
  const nextPage = () => setPage((p) => p + 1);

  const pagesCount = Number.isFinite(total) ? Math.ceil(total / perPage) : 0;


  const toggleShowMore = (saleId) => {
    setShowMoreMap((prev) => ({
      ...prev,
      [saleId]: !prev[saleId],
    }));
  };

  const getItemName = (detail) => {
    return (
      detail?.item?.name?.[i18n.language] ||
      detail?.item?.name?.ckb ||
      detail?.item?.name?.en ||
      "-"
    );
  };

  const getSortedFactories = (saleItem, saleDetail) => {
    let factories = [];

    if (Array.isArray(saleItem?.factory) && saleItem.factory.length > 0) {
      factories = saleItem.factory;
    } else if (
      Array.isArray(saleDetail?.factories) &&
      saleDetail.factories.length > 0
    ) {
      factories = saleDetail.factories.filter((f) => {
        if (!saleItem?.id) return true;
        return (
          f?.sale_item_id === saleItem.id ||
          f?.saleItem?.id === saleItem.id ||
          f?.sale_item?.id === saleItem.id
        );
      });
    } else if (saleItem?.factory) {
      factories = [saleItem.factory];
    }

    return [...factories].sort((a, b) => {
      if (a?.id && b?.id) return a.id - b.id;
      return 0;
    });
  };

  const getLastFactory = (saleItem, saleDetail) => {
    const factories = getSortedFactories(saleItem, saleDetail);
    return factories.length ? factories[factories.length - 1] : null;
  };

  const getLastDoneQuantity = (saleItem, saleDetail) => {
    const lastFactory = getLastFactory(saleItem, saleDetail);
    return Number(lastFactory?.done_quantity || 0);
  };





  const hasValidImages = (files = []) => {
    return files.some((file) => {
      // File object (uploaded)
      if (file instanceof File) {
        return file.type?.startsWith("image/");
      }

      // String URL/path
      if (typeof file === "string") {
        return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(file);
      }

      // Object with path or url
      if (typeof file === "object" && file !== null) {
        const path = file.url || file.path || file.name || "";
        return /\.(jpg|jpeg|png|gif|webp|bmp|svg)$/i.test(path);
      }

      return false;
    });
  };

  const renderItemCell = (saleDetail, saleItem) => {
    try {
      const services = JSON.parse(saleItem?.factory?.sale_item_service_ids || "[]");

      if (Array.isArray(services) && services.length) {
        const grouped = services.reduce((map, svc) => {
          const id = svc.sale_invoice_detail_id;
          if (!map[id]) map[id] = [];
          map[id].push(svc);
          return map;
        }, {});

        const groupedValues = Object.values(grouped);

        return groupedValues.map((items, idx) => {
          const { item_name, color_name } = items[0] || {};
          return (
            <React.Fragment key={idx}>
              <span>{`${item_name}-${color_name}`}</span>
              {idx < groupedValues.length - 1 && (
                <span className="mx-1 text-red-500 font-bold">+</span>
              )}
            </React.Fragment>
          );
        });
      }
    } catch (e) { }

    return (
      <>
        <div className="font-medium">{getItemName(saleDetail)}</div>
        <div className="text-sm text-gray-500">{saleDetail?.color?.name || "-"}</div>
      </>
    );
  };

  const buildDoubleGlassRows = (sale) => {
    const rows = [];
    let globalIndex = 1;
    let invoiceTotalQuantity = 0;
    let invoiceTotalSquare = 0;

    (sale.sale_details || []).forEach((detail) => {
      const groupedMap = new Map();

      (detail.sale_items || []).forEach((saleItem) => {
        const key = `${detail.id}_${saleItem.id}`;
        if (!groupedMap.has(key)) {
          groupedMap.set(key, []);
        }
        groupedMap.get(key).push(saleItem);
      });

      const visibleEntries = [];
      groupedMap.forEach((items) => {
        visibleEntries.push(items[0]);
      });

      const hasImages = visibleEntries.length > 0 && hasValidImages(detail.images);
      const showDetails = showDetailsMap[detail.id] ?? false;

      if (hasImages) {
        const filteredImages = detail.images.filter((img) =>
          hasValidImages([img])
        );

        rows.push({
          type: "images",
          key: `double-images-${detail.id}`,
          element: (
            <tr key={`double-images-${detail.id}`} className="table-row bg-white border-b">
              <td colSpan={8} className="table-cell border p-4 bg-white text-center">
                <div className="flex flex-col items-center gap-3 w-full">
                  <div className="flex flex-row flex-nowrap justify-center gap-2 sm:gap-4 overflow-x-auto max-w-full w-full py-1">
                    {filteredImages.map((image, imgIndex) => (
                      <SalesGallery key={imgIndex} image={image} imgIndex={imgIndex} images={filteredImages} title={detail.customer_note || getItemName(detail)} />
                    ))}
                  </div>
                  <button
                    onClick={() => toggleDetails(detail.id)}
                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg shadow transition-all duration-200 mt-2"
                  >
                    {showDetails
                      ? t("hide_details") || "Hide Details"
                      : t("show_details") || "Details"}
                  </button>
                </div>
              </td>
            </tr>
          ),
        });
      } else {
        rows.push({
          type: "details-toggle",
          key: `double-toggle-${detail.id}`,
          element: (
            <tr key={`double-toggle-${detail.id}`} className="table-row bg-gray-50 border-b">
              <td colSpan={8} className="table-cell border py-3 sm:px-3 bg-gray-50 text-center">
                <button
                  onClick={() => toggleDetails(detail.id)}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-lg shadow transition-all duration-200"
                >
                  {showDetails
                    ? t("hide_details") || "Hide Details"
                    : t("show_details") || "Details"}
                </button>
              </td>
            </tr>
          ),
        });
      }
      if (showDetails && visibleEntries.length > 0) {
        rows.push({
          type: "detail-header",
          key: `double-header-${detail.id}`,
          element: (
            <tr key={`double-header-${detail.id}`} className="table-row bg-green-100 text-green-800 font-semibold text-xs sm:text-sm">
              <th className="p-1.5 sm:p-3 border">#</th>
              <th className="p-1.5 sm:p-3 border w-40 sm:w-72">{t("item")}</th>
              <th className="p-1.5 sm:p-3 border">{t("size")}</th>
              <th className="p-1.5 sm:p-3 border">{t("quantity")}</th>
              <th className="p-1.5 sm:p-3 border">{t("done_quantity")}</th>
              <th className="p-1.5 sm:p-3 border">{t("meter")}</th>
              <th className="p-1.5 sm:p-3 border">{t("price")}</th>
              <th className="p-1.5 sm:p-3 border">{t("total")}</th>
            </tr>
          ),
        });
      }

      visibleEntries.forEach((saleItem) => {
        const height = parseFloat(saleItem.height || 0);
        const width = parseFloat(saleItem.width || 0);
        const quantity = parseInt(saleItem.quantity || 0, 10);
        const price = parseInt(saleItem.table_price || 0, 10);
        const doneQty = getLastDoneQuantity(saleItem, detail);
        const square = (height / 100) * (width / 100) * quantity;
        const currentIndex = globalIndex++;

        // Add to totals
        invoiceTotalQuantity += quantity;
        invoiceTotalSquare += square;

        if (showDetails) {
          rows.push({
            type: "item",
            key: `double-item-${saleItem.id}`,
            element: (
              <tr 
                key={`double-item-${saleItem.id}`} 
                className="table-row border-b hover:bg-gray-50 text-xs sm:text-sm transition-all duration-200"
              >
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{currentIndex}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{detail.customer_note || "-"}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{height} × {width}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{quantity}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>
                    {doneQty}
                    {!getLastFactory(saleItem, detail) && (
                      <span className="ml-1 text-[10px] text-gray-400 block sm:inline">(no factory)</span>
                    )}
                  </span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{square.toFixed(3)}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{price} {sale?.currency?.symbol}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border font-semibold">
                  <span>
                    {Number(price * square).toFixed(sale?.currency?.decimal)}{" "}
                    {sale?.currency?.symbol}
                  </span>
                </td>
              </tr>
            ),
          });
        }
      });
    });

    // Add totals row for double glass
    if (invoiceTotalQuantity > 0) {
      rows.push({
        type: "totals",
        key: "double-totals",
        element: (
          <tr 
            key="double-totals" 
            className="table-row bg-green-50 font-bold text-xs sm:text-sm"
          >
            <td colSpan={3} className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              {t("total") || "Total"}
            </td>
            <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              <span>{invoiceTotalQuantity} {t("quantity") || ""}</span>
            </td>
            <td className="hidden sm:table-cell px-1.5 py-2 sm:px-3 sm:py-3 text-center border"></td>
            <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              <span>{invoiceTotalSquare.toFixed(3)} m²</span>
            </td>
            <td colSpan={2} className="hidden sm:table-cell px-1.5 py-2 sm:px-3 sm:py-3 text-center border"></td>
          </tr>
        ),
      });
    }

    return rows;
  };

  const buildNormalRows = (sale) => {
    const rows = [];
    let invoiceTotalQuantity = 0;
    let invoiceTotalSquare = 0;

    sale.sale_details?.forEach((saleDetail) => {
      const visibleSaleItems = saleDetail.sale_items || [];

      const servicesForDetail =
        saleDetail.sale_invoice_detail_services?.filter(
          (svc) => svc.sale_invoice_detail_id === saleDetail.id
        ) || [];

      const serviceTotal = servicesForDetail.reduce(
        (sum, svc) => sum + parseFloat(svc.price || 0),
        0
      );

      const itemsCount = visibleSaleItems.length || 1;
      const sharedService = itemsCount ? serviceTotal / itemsCount : 0;

      const hasImages = visibleSaleItems.length > 0 && hasValidImages(saleDetail.images);
      const showDetails = showDetailsMap[saleDetail.id] ?? false;

      if (hasImages) {
        const filteredImages = saleDetail.images.filter((img) =>
          hasValidImages([img])
        );

        rows.push({
          type: "images",
          key: `images-${saleDetail.id}`,
          element: (
            <tr key={`images-${saleDetail.id}`} className="table-row bg-white border-b">
              <td colSpan={7} className="table-cell border p-4 bg-white text-center">
                <div className="flex flex-col items-center gap-3 w-full">
                  <div className="flex flex-row flex-nowrap justify-center gap-2 sm:gap-4 overflow-x-auto max-w-full w-full py-1">
                    {filteredImages.map((image, imgIndex) => (
                      <SalesGallery key={imgIndex} image={image} imgIndex={imgIndex} images={filteredImages} title={getItemName(saleDetail)} />
                    ))}
                  </div>
                  <button
                    onClick={() => toggleDetails(saleDetail.id)}
                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2.5 rounded-lg shadow transition-all duration-200 mt-2"
                  >
                    {showDetails
                      ? t("hide_details") || "Hide Details"
                      : t("show_details") || "Details"}
                  </button>
                </div>
              </td>
            </tr>
          ),
        });
      } else {
        rows.push({
          type: "details-toggle",
          key: `toggle-${saleDetail.id}`,
          element: (
            <tr key={`toggle-${saleDetail.id}`} className="table-row bg-gray-50 border-b">
              <td colSpan={7} className="table-cell border py-3 sm:px-3 bg-gray-50 text-center">
                <button
                  onClick={() => toggleDetails(saleDetail.id)}
                  className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold px-5 py-2 rounded-lg shadow transition-all duration-200"
                >
                  {showDetails
                    ? t("hide_details") || "Hide Details"
                    : t("show_details") || "Details"}
                </button>
              </td>
            </tr>
          ),
        });
      }
      if (showDetails && visibleSaleItems.length > 0) {
        rows.push({
          type: "detail-header",
          key: `header-${saleDetail.id}`,
          element: (
            <tr key={`header-${saleDetail.id}`} className="table-row bg-gray-100 text-gray-700 font-semibold text-xs sm:text-sm">
              <th className="p-1.5 sm:p-3 border">{t("item")}</th>
              <th className="p-1.5 sm:p-3 border">{t("size")}</th>
              <th className="p-1.5 sm:p-3 border">{t("quantity")}</th>
              <th className="p-1.5 sm:p-3 border">{t("done_quantity")}</th>
              <th className="p-1.5 sm:p-3 border">{t("meter")}</th>
              <th className="p-1.5 sm:p-3 border">{t("price")}</th>
              <th className="p-1.5 sm:p-3 border">{t("total")}</th>
            </tr>
          ),
        });
      }

      visibleSaleItems.forEach((saleItem) => {
        const height = parseFloat(saleItem?.height || 0);
        const width = parseFloat(saleItem?.width || 0);
        const quantity = parseInt(saleItem?.quantity || 0, 10);
        const meter = (width / 100) * (height / 100);
        const lineSquare = saleItem.square !== null && saleItem.square !== ''
          ? parseFloat(saleItem.square)
          : meter * quantity;
        const doneQty = getLastDoneQuantity(saleItem, saleDetail);
        const price = parseFloat(saleItem.table_price || 0);
        const rowTotal = meter * quantity * price + sharedService;

        // Add to totals
        invoiceTotalQuantity += quantity;
        invoiceTotalSquare += lineSquare;

        if (showDetails) {
          rows.push({
            type: "item",
            key: `item-${saleItem.id}`,
            element: (
              <tr 
                key={`item-${saleItem.id}`} 
                className="table-row border-b hover:bg-gray-50 text-xs sm:text-sm transition-all duration-200"
              >
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{renderItemCell(saleDetail, saleItem)}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{saleItem.height} × {saleItem.width}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{quantity}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{doneQty}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{lineSquare.toFixed(2)} m²</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
                  <span>{price.toFixed(2)} {sale?.currency?.symbol}</span>
                </td>
                <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border font-semibold">
                  <span>{rowTotal.toFixed(2)} {sale?.currency?.symbol}</span>
                </td>
              </tr>
            ),
          });
        }
      });
    });

    // Add totals row for normal glass
    if (invoiceTotalQuantity > 0) {
      rows.push({
        type: "totals",
        key: "normal-totals",
        element: (
          <tr 
            key="normal-totals" 
            className="table-row bg-blue-50 font-bold text-xs sm:text-sm"
          >
            <td colSpan={2} className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              {t("total") || "Total"}
            </td>
            <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              <span>{invoiceTotalQuantity} {t("quantity") || ""}</span>
            </td>
            <td className="hidden sm:table-cell px-1.5 py-2 sm:px-3 sm:py-3 text-center border"></td>
            <td className="px-2 py-2 sm:px-3 sm:py-3 text-center border">
              <span>{invoiceTotalSquare.toFixed(2)} m²</span>
            </td>
            <td colSpan={2} className="hidden sm:table-cell px-1.5 py-2 sm:px-3 sm:py-3 text-center border"></td>
          </tr>
        ),
      });
    }

    return rows;
  };

  return (
    <div
      className="min-h-screen bg-gray-100 p-4 sm:p-6"
      dir={i18n.language === "ar" || i18n.language === "ckb" ? "rtl" : "ltr"}
    >
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl font-bold mb-6 text-center text-gray-800">
          {t("factory")}
        </h2>

        <div className="bg-white rounded-xl shadow-sm border p-4 mb-6">
          <h3 className="text-lg font-bold text-gray-800 mb-4 text-center">
            {t("searchStartDate")}
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div className="flex flex-col">
              <label htmlFor="from" className="mb-1 text-sm font-medium text-gray-700">
                {t("from")}
              </label>
              <input
                type="date"
                name="from"
                value={from}
                onChange={(e) => {
                  setFrom(e.target.value);
                  setPage(1);
                }}
                className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex flex-col">
              <label htmlFor="to" className="mb-1 text-sm font-medium text-gray-700">
                {t("to")}
              </label>
              <input
                type="date"
                name="to"
                value={to}
                onChange={(e) => {
                  setTo(e.target.value);
                  setPage(1);
                }}
                className="border rounded-lg px-3 py-2 outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="col-span-full">
              <SelectField
                value={saleInvoiceId}
                onChange={setSaleInvoiceId}
                fetchData={fetchSalesForDropdown}
                renderOption={(item) => `${item.invoice_number} `}
                renderValue={(item) => `${item.invoice_number} `}
                preload={false}
                labelKey={t("invoice_number")}
                valueKey="id"
                placeholder={t("sale_invoice_id")}
                searchPlaceholder={t("sale_invoice_id")}
                searchFields={["invoice_number", "id"]}
                searchParams={{ status: "not_complete", type: "Glass" }}
                pageSize={10}
              />
            </div>
          </div>
        </div>

        {sales.map((sale, index) => {
          const isDouble = sale.glass_type === "double";

          const normalRows = !isDouble ? buildNormalRows(sale) : [];
          const doubleRows = isDouble ? buildDoubleGlassRows(sale) : [];

          const activeRows = isDouble ? doubleRows : normalRows;
          const hasAnyItems = (sale.sale_details || []).some(
            (detail) => detail.sale_items && detail.sale_items.length > 0
          );

          if (!hasAnyItems) return null;

          const firstRows = activeRows.slice(0, 6);
          const hiddenRows = activeRows.slice(6);
          const isExpanded = showMoreMap[sale.id];
          const colSpanCount = isDouble ? 8 : 7;

          const anyDetailOpen = (sale.sale_details || []).some(
            (detail) => showDetailsMap[detail.id]
          );

          return (
            <div
              key={sale.id || index}
              className="bg-white shadow-md rounded-2xl mb-6 border border-gray-200 overflow-hidden"
            >
              <div
                className={`${
                  isDouble
                    ? "bg-gradient-to-r from-emerald-600 to-teal-700"
                    : "bg-gradient-to-r from-blue-700 to-indigo-800"
                } text-white px-4 py-3.5 shadow-sm`}
              >
                <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-3">
                  <div className="flex items-center gap-3 flex-wrap">
                    <span className="bg-white/20 backdrop-blur-md px-3 py-1 rounded-xl text-xs sm:text-sm font-bold tracking-wide border border-white/20 shadow-inner">
                      {t("invoice")}: {sale?.invoice_number}
                    </span>
                    <span className="text-white/90 text-xs sm:text-sm font-medium">
                      {t("sale_invoice_id")}: <span className="font-bold text-white">{sale?.id}</span>
                    </span>
                  </div>

                  {/* Print Action Buttons */}
                  {canPrint && (
                    <div className="flex items-center gap-2 flex-wrap no-print">
                      <button
                        type="button"
                        onClick={() => handlePrint(sale, "full")}
                        className="bg-white/20 hover:bg-white/30 text-white border border-white/30 px-3 py-1.5 rounded-xl font-bold flex items-center gap-1.5 text-xs sm:text-sm shadow-sm transition active:scale-95 cursor-pointer"
                        title={t("print")}
                      >
                        <Printer className="w-4 h-4" />
                        <span>{t("print")}</span>
                      </button>

                      <button
                        type="button"
                        onClick={() => handlePrint(sale, "factory")}
                        className="bg-amber-500/80 hover:bg-amber-500 text-white border border-amber-300/40 px-3 py-1.5 rounded-xl font-bold flex items-center gap-1.5 text-xs sm:text-sm shadow-sm transition active:scale-95 cursor-pointer"
                        title={t("print_factory")}
                      >
                        <Printer className="w-4 h-4" />
                        <span>{t("print_factory")}</span>
                      </button>
                    </div>
                  )}

                  <div className="flex flex-wrap items-center gap-2 sm:gap-2.5 text-xs sm:text-sm">
                    <div className="flex items-center gap-1.5 bg-black/15 sm:bg-white/15 backdrop-blur-md px-3 py-1.5 rounded-xl border border-white/20 shadow-sm">
                      <Calendar className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-blue-200" />
                      <span className="opacity-90 font-normal">{t("start_date")}:</span>
                      <span className="font-bold tracking-wide dir-ltr">{sale?.date ? sale.date.split(" ")[0] : "—"}</span>
                    </div>

                    <div className="flex items-center gap-1.5 bg-black/15 sm:bg-white/15 backdrop-blur-md px-3 py-1.5 rounded-xl border border-white/20 shadow-sm">
                      <CalendarCheck className="w-3.5 h-3.5 sm:w-4 sm:h-4 text-emerald-200" />
                      <span className="opacity-90 font-normal">{t("terminate_date")}:</span>
                      <span className="font-bold tracking-wide dir-ltr">{sale?.terminate_date ? sale.terminate_date.split(" ")[0] : "—"}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="p-4">
                <div className="overflow-x-auto">
                  <table className={`table w-full border-collapse overflow-hidden rounded-lg text-xs sm:text-sm ${anyDetailOpen ? (isDouble ? "min-w-[750px]" : "min-w-[700px]") : "w-full"}`}>
                    <tbody className="table-row-group">
                      {firstRows.map((row) => row.element)}

                      {hiddenRows.length > 0 && !isExpanded && (
                        <tr className="block sm:table-row bg-gray-50">
                          <td colSpan={colSpanCount} className="block sm:table-cell border-none sm:border text-center py-4 bg-gray-50 w-full">
                            <button
                              onClick={() => toggleShowMore(sale.id)}
                              className="bg-gray-800 hover:bg-gray-900 text-white px-5 py-2 rounded-md"
                            >
                              {t("show_more") || "Show"} {hiddenRows.filter(r => r.type === "item").length}{" "}
                              {t("more_items") || "more items"}
                            </button>
                          </td>
                        </tr>
                      )}

                      {isExpanded && hiddenRows.map((row) => row.element)}

                      {hiddenRows.length > 0 && isExpanded && (
                        <tr className="block sm:table-row bg-gray-50">
                          <td colSpan={colSpanCount} className="block sm:table-cell border-none sm:border text-center py-4 bg-gray-50 w-full">
                            <button
                              onClick={() => toggleShowMore(sale.id)}
                              className="bg-red-600 hover:bg-red-700 text-white px-5 py-2 rounded-md"
                            >
                              {t("show_less") || "Show Less"}
                            </button>
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>

                     {(() => {
                  // Filter details that actually have a customer note
                  const detailsWithNotes = sale?.sale_details?.filter((detail) => isDouble ? detail?.extra_note: detail.customer_note ) || [];
                  const hasNotes = detailsWithNotes.length > 0;

                  // Scenario 1: Has notes and NOT double (Show standard Customer Notes Table)
                  if (hasNotes && !isDouble) {
                    return (
                      <div className="mt-5">
                        <div className="mb-2 text-lg md:w-4/12 flex justify-center mx-auto px-5 py-1 font-bold text-center bg-blue-950 text-gray-100">
                          {t("customer_note") || "Customer Notes"}
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden text-xs sm:text-sm">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="p-1.5 sm:p-3 text-center border">{t("#") || "Item"}</th>
                                <th className="p-1.5 sm:p-3 text-center border">
                                  {t("customer_note") || "Customer Note"}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {detailsWithNotes.map((detail, noteIndex) => (
                                <tr key={noteIndex} className="odd:bg-white even:bg-gray-50 text-[11px] sm:text-sm">
                                  <td className="p-1.5 sm:p-3 border text-center">{noteIndex + 1}</td>
                                  <td className="p-1.5 sm:p-3 border text-center">{detail.customer_note}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  }

                  // Scenario 2: Has notes and IS double (Show Extra Notes Table)
                  if (hasNotes && isDouble) {
                    return (
                      <div className="mt-5">
                        <div className="mb-2 text-lg md:w-4/12 flex justify-center mx-auto px-5 py-1 font-bold text-center bg-red-950 text-gray-100">
                          {t("note") || "Extra Notes"}
                        </div>
                        <div className="overflow-x-auto">
                          <table className="w-full border border-gray-200 rounded-lg overflow-hidden text-xs sm:text-sm">
                            <thead className="bg-gray-100">
                              <tr>
                                <th className="p-1.5 sm:p-3 text-center border">{t("#") || "Item"}</th>
                                <th className="p-1.5 sm:p-3 text-center border">
                                  {t("note") || "Extra Note"}
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {detailsWithNotes.map((detail, noteIndex) => (
                                <tr key={noteIndex} className="odd:bg-white even:bg-gray-50 text-[11px] sm:text-sm">
                                  <td className="p-1.5 sm:p-3 border text-center">{noteIndex + 1}</td>
                                  <td className="p-1.5 sm:p-3 border text-center">{detail.extra_note}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      </div>
                    );
                  }

                  return null;
                })()}

                {sale?.expenses?.length > 0 && (
                  <div className="mt-5">
                    <div className="mb-2 text-lg font-bold text-center flex justify-center">
                      <p className="bg-red-500 md:w-4/12 px-4 py-1 rounded-md border border-red-400 text-white">
                        {t("expense")}
                      </p>
                    </div>
                    <div className="overflow-x-auto">
                      <table className="w-full border border-gray-200 rounded-lg overflow-hidden text-xs sm:text-sm">
                        <thead className="bg-gray-100">
                          <tr>
                            <th className="p-1.5 sm:p-3 text-center border">{t("note")}</th>
                            <th className="p-1.5 sm:p-3 text-center border">{t("amount")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sale.expenses.map((expense, expenseIndex) => (
                            <tr key={expenseIndex} className="odd:bg-white even:bg-gray-50 text-[11px] sm:text-sm">
                              <td className="p-1.5 sm:p-3 border text-center">{expense.note}</td>
                              <td className="p-1.5 sm:p-3 border text-center">
                                {expense.amount} {sale?.currency?.symbol}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                )}

                <div
                  className={`flex justify-between items-center ${isDouble ? "bg-green-50" : "bg-blue-50"
                    } p-4 rounded-lg mt-4`}
                >
                  <div className="flex gap-1 items-center">
                    <div className={`w-2 h-2 rounded-full ${sale?.is_complete ? "bg-green-500" : "bg-red-500"}`}></div>
                    <span className={sale?.is_complete ? "text-green-700 font-bold" : "text-red-700 font-bold"}>{sale?.is_complete ? t("completed") : t("not_completed")}</span>
                  </div>
                  <p className={`text-lg font-bold ${isDouble ? "text-green-700" : "text-blue-700"}`}>
                    {t("total")} : {parseFloat(isDouble ? sale?.total_double : sale?.total || 0).toFixed(2)}{" "}
                    {sale?.currency?.symbol || "$"}
                  </p>
                </div>
              </div>
            </div>
          );
        })}

        {total > 0 && (
          <Pagination
            page={page}
            setPage={setPage}
            showPage={pagesCount}
            nextPage={nextPage}
            prevPage={prevPage}
          />
        )}

        {printData && (
          <PrintReceipt sale={printData.sale} mode={printData.mode} />
        )}
      </div>
    </div>
  );
}

export default Sale;